module.exports = __webpack_public_path__ + "static/media/nasdaq.f73103b0.png";